<div class="text-center mb-4">
    <div class="mb-3">
        <img src="/assets/success.svg">
    </div>
    <div class="mb-3 fs-2 fw-bold">TEST COMPLETE</div>
    <div class="text-muted">
        Great job! You’ve completed<br>the {{title}} test.
    </div>
</div>
<div class="res w-100 text-muted mb-4 justify-content-between">
    <div class="font-book">
        POINT
    </div>
    <div class="text-end fw-bold text-primary">
        {{point}}
    </div>
</div>
<div class="res w-100 text-muted mb-4 justify-content-between">
    <div class="font-book">
        ELAPSED TIME
    </div>
    <div class="text-end fw-bold text-primary">
        {{timeString}}
    </div>
</div>
<div class="text-center mb-4" (click)="done()">
    <button class="btn btn-done rounded-4">
        Next
    </button>
</div>
